import styled from 'styled-components';

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.75rem 0;
  width: min(760px, 78vw);
  color: ${(props) => props.theme.colors.onSurface};
  .input {
    width: 100%;
    box-sizing: border-box;
  }
  textarea {
    resize: vertical;
  }
  @media (max-width: 620px) {
    width: 100%;
  }
`;
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  @media (max-width: 620px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
export const Label = styled.label`
  display: block;
  margin-bottom: 0.4rem;
  font-weight: 600;
`;
export const CheckLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
export const HelpText = styled.p`
  margin: 0.4rem 0 0;
  font-size: 0.85rem;
`;
export const Notice = styled.div`
  padding: 0.75rem;
  border: 1px solid ${(props) => props.theme.colors.onSurfaceLight};
  border-radius: 4px;
`;
export const Confirmation = styled.p`
  max-width: 32rem;
  padding: 1rem;
`;
export const MessageBody = styled.p`
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  margin: 0;
`;
export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`;
